import React, { useRef } from 'react';
import { toast } from 'react-toastify';
import CustomToast from 'src/components/CustomToast';
import { RESEND_ERROR, sentCodeSuccess } from 'src/containers/Core/Messages';
import EmailVerificationForm from 'src/containers/UserManagement/EmailVerificationForm';

type EmailVerificationProps = {
  email: string;
  resendCallback: (email: string) => void;
  verifyCallback: (otp: string, email: string) => void;
};

const EmailVerification: React.FC<EmailVerificationProps> = ({ email, resendCallback, verifyCallback }) => {
  const formRef = useRef(null);

  const resendOTP = async () => {
    try {
      if (formRef && formRef.current) {
        formRef.current.resetForm();
      }

      await resendCallback(email);
      toast(<CustomToast type="success" description={sentCodeSuccess(email, true)} />, { className: 'success' });
    } catch (error) {
      toast(<CustomToast description={RESEND_ERROR} />);
    }
  };

  if (!email) {
    return null;
  }

  return (
    <div className="d-flex flex-column font-size-14">
      <h2 className={`mb-3 font-weight-bold text-primary`}>Email Verification Code</h2>
      <div>
        A verification code has been sent to your email <span className="font-weight-bold">{email}</span>
      </div>
      <EmailVerificationForm ref={formRef} verifyCallback={(otp: string) => verifyCallback(otp, email)} />
      <div className="mt-3">Didn’t receive the verification code?</div>
      <div className="text-primary c-pointer" onClick={resendOTP}>
        Resend
      </div>
    </div>
  );
};

export default EmailVerification;
